<!-- 中西会诊首页 -->
<template>
  <div class="tradiWrap">
    <div class="contain">
      <!-- <div class="topLine">
        <div class="l">
          <img src="@/assets/img/1.png" alt="">
          <div>
            <h5>医师姓名：{{ this.userInfo.realName }}</h5>
            <p>{{ this.userInfo.phone }}</p>
          </div>
        </div>
        <div class="r">

        </div>
      </div> -->
      <!-- <topNav></topNav> -->
      <div class="mainWrap">
        <div class="l">
          <!-- <div class="cusBtn addBtn" @click="addUser">新增患者</div> -->
          <div class="input_search">
            <el-input placeholder="请输入姓名/医案号" size="mini" clearable v-model="searchObj.name" @change="searchChange">
            </el-input>
            <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
          </div>

          <!-- 患者表格区 -->
          <el-table :data="hzTableData" border ref="singleTable" height="614" highlight-current-row
            @current-change="currentChange" style="width: 100%" size='mini'>
            <el-table-column label="序号" type="index" width="45" align="center"></el-table-column>
            <el-table-column label="姓名" width="60" align="center">
              <template slot-scope="scope">
                <p class="usrName" :title="scope.row.name">{{ scope.row.name }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="cards" label="医案号" align="center">
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination small background layout=" prev, pager, next,jumper" :total="total" :current-page.sync="pageNum" :pageCount="6"
              :page-size="pageSize" @current-change="handleCurrentChange"></el-pagination>
          </div>
        </div>
        <div class="r">
          <div class="main_r_top">
            <div class="main_r_top_innr">
              <div class="form">
                <el-select size="mini" v-model="detailSearchObj.type" @change="getDetailList" placeholder="查看全部"
                  style="width: 120px;">
                  <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <el-select size="mini" v-model="detailSearchObj.createBy" @change="getDetailList" placeholder="医生姓名"
                  style="width: 120px;" clearable>
                  <el-option v-for="item in options2" :key="item.id" :label="item.realName" :value="item.id">
                  </el-option>
                </el-select>
                <el-date-picker size="mini" v-model="detailSearchObj.date" type="daterange" range-separator="至"
                  value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" @change="getDetailList"
                  :picker-options="pickerOptions">
                </el-date-picker>
              </div>
              <div class="cusBtn jumpBtn" @click="jumpInfo()">前往诊断</div>
            </div>
          </div>
          <div class="main_r_btm" v-if="recodeArr.length">
            <el-collapse v-model="activeName" accordion @change="handleChange">
              <el-collapse-item :name="index" v-for="(item, index) in recodeArr" :key="index">
                <template slot="title">
                  <div class="rec_l">
                    <span>患者姓名：{{ item.medicalName }}</span>
                    <span>医生姓名：{{ item.createByName ? item.createByName : '' }}</span>
                    <span>{{ item.updateDate }}</span>
                  </div>
                </template>
                <div class="rec-content" v-show="detailSearchObj.type != 1">
                  <div class="rec_zd">
                    <div class="zd_item">
                      <h4>中医诊断</h4>
                      <div class="zd_item-c">
                        {{ showData.diagnosisChinese ? showData.diagnosisChinese : '' }}
                      </div>
                    </div>
                    <div class="zd_item">
                      <h4>治疗方案</h4>
                      <div class="zd_item-c">
                        {{ showData.treatmentPlan ? showData.treatmentPlan : '' }}
                      </div>
                    </div>
                    <div class="zd_item">
                      <h4>西医诊断</h4>
                      <div class="zd_item-c">
                        {{ showData.diagnosisWestern ? showData.diagnosisWestern : '' }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tips" v-if="detailSearchObj.type == 1 && !medicalMeridianRecordList.length">
                  <el-alert title="该条记录没有穴位信息" type="warning" :closable="false" show-icon>
                  </el-alert>
                </div>
                <div class="zj" v-show="detailSearchObj.type != 2 && medicalMeridianRecordList.length">
                  <div class="zj-item" v-for="(item2, index2) in medicalMeridianRecordList" :key="index2">
                    <div class="zj-item-t">
                      <div class="zj-item-box2">{{ item2.time + '-' + item2.meridianNameDesc }}</div>
                    </div>
                    <div class="zj-item-box4">
                      <div class="box4">
                        <div class="zj-item-box3">金 - {{ item2.gold }}：</div>
                        <div class="box4-1" v-if="!(!item2.yangGold && item2.yangGold !== 0)">阳</div>
                        <div class="box4-3" v-if="!(!item2.yangGold && item2.yangGold !== 0)">
                          <span v-if="item2.yangGold === 0">补针</span>
                          <span v-if="item2.yangGold === 1">直刺</span>
                          <span v-if="item2.yangGold === 2">泄针</span>
                        </div>
                        <div class="box4-1 leftM" v-if="!(!item2.yinGold && item2.yinGold !== 0)">阴</div>
                        <div class="box4-3" v-if="!(!item2.yinGold && item2.yinGold !== 0)">
                          <span v-if="item2.yinGold === 0">补针</span>
                          <span v-if="item2.yinGold === 1">直刺</span>
                          <span v-if="item2.yinGold === 2">泄针</span>
                        </div>
                        <div class="box4-3"
                          v-if="!item2.yinGold && item2.yinGold !== 0 && !item2.yangGold && item2.yangGold !== 0">无
                        </div>
                      </div>
                      <div class="box4">
                        <div class="zj-item-box3">木 - {{ item2.wood }}：</div>
                        <div class="box4-1" v-if="!(!item2.yangWood && item2.yangWood !== 0)">阳</div>
                        <div class="box4-3" v-if="!(!item2.yangWood && item2.yangWood !== 0)">
                          <span v-if="item2.yangWood === 0">补针</span>
                          <span v-if="item2.yangWood === 1">直刺</span>
                          <span v-if="item2.yangWood === 2">泄针</span>
                        </div>
                        <div class="box4-1 leftM" v-if="!(!item2.yinWood && item2.yinWood !== 0)">阴</div>
                        <div class="box4-3" v-if="!(!item2.yinWood && item2.yinWood !== 0)">
                          <span v-if="item2.yinWood === 0">补针</span>
                          <span v-if="item2.yinWood === 1">直刺</span>
                          <span v-if="item2.yinWood === 2">泄针</span>
                        </div>
                        <div class="box4-3"
                          v-if="!item2.yinWood && item2.yinWood !== 0 && !item2.yangWood && item2.yangWood !== 0">无
                        </div>
                      </div>
                      <div class="box4">
                        <div class="zj-item-box3">水 - {{ item2.water }}：</div>
                        <div class="box4-1" v-if="!(!item2.yangWater && item2.yangWater !== 0)">阳</div>
                        <div class="box4-3" v-if="!(!item2.yangWater && item2.yangWater !== 0)">
                          <span v-if="item2.yangWater === 0">补针</span>
                          <span v-if="item2.yangWater === 1">直刺</span>
                          <span v-if="item2.yangWater === 2">泄针</span>
                        </div>
                        <div class="box4-1 leftM" v-if="!(!item2.yinWater && item2.yinWater !== 0)">阴</div>
                        <div class="box4-3" v-if="!(!item2.yinWater && item2.yinWater !== 0)">
                          <span v-if="item2.yinWater === 0">补针</span>
                          <span v-if="item2.yinWater === 1">直刺</span>
                          <span v-if="item2.yinWater === 2">泄针</span>
                        </div>
                        <div class="box4-3"
                          v-if="!item2.yinWater && item2.yinWater !== 0 && !item2.yangWater && item2.yangWater !== 0">
                          无</div>
                      </div>
                      <div class="box4">
                        <div class="zj-item-box3">火 - {{ item2.fire }}：</div>
                        <div class="box4-1" v-if="!(!item2.yangFire && item2.yangFire !== 0)">阳</div>
                        <div class="box4-3" v-if="!(!item2.yangFire && item2.yangFire !== 0)">
                          <span v-if="item2.yangFire === 0">补针</span>
                          <span v-if="item2.yangFire === 1">直刺</span>
                          <span v-if="item2.yangFire === 2">泄针</span>
                        </div>
                        <div class="box4-1 leftM" v-if="!(!item2.yinFire && item2.yinFire !== 0)">阴</div>
                        <div class="box4-3" v-if="!(!item2.yinFire && item2.yinFire !== 0)">
                          <span v-if="item2.yinFire === 0">补针</span>
                          <span v-if="item2.yinFire === 1">直刺</span>
                          <span v-if="item2.yinFire === 2">泄针</span>
                        </div>
                        <div class="box4-3"
                          v-if="!item2.yinFire && item2.yinFire !== 0 && !item2.yangFire && item2.yangFire !== 0">无
                        </div>
                      </div>
                      <div class="box4">
                        <div class="zj-item-box3">土 - {{ item2.soil }}：</div>
                        <div class="box4-1" v-if="!(!item2.yangSoil && item2.yangSoil !== 0)">阳</div>
                        <div class="box4-3" v-if="!(!item2.yangSoil && item2.yangSoil !== 0)">
                          <span v-if="item2.yangSoil === 0">补针</span>
                          <span v-if="item2.yangSoil === 1">直刺</span>
                          <span v-if="item2.yangSoil === 2">泄针</span>
                        </div>
                        <div class="box4-1 leftM" v-if="!(!item2.yinSoil && item2.yinSoil !== 0)">阴</div>
                        <div class="box4-3" v-if="!(!item2.yinSoil && item2.yinSoil !== 0)">
                          <span v-if="item2.yinSoil === 0">补针</span>
                          <span v-if="item2.yinSoil === 1">直刺</span>
                          <span v-if="item2.yinSoil === 2">泄针</span>
                        </div>
                        <div class="box4-3"
                          v-if="!item2.yinSoil && item2.yinSoil !== 0 && !item2.yangSoil && item2.yangSoil !== 0">无
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="yqhy"
                  v-show="detailSearchObj.type != 2 && detailSearchObj.type != 1 && medicalExamineList.length">
                  <h2>
                    <div>仪器及化验</div>
                    <div class="btn" @click="addFileItem()" v-if="false">
                      <div class="btn-l">
                        <i class="el-icon-plus"></i>
                      </div>
                      <div class="btn-r">添加</div>
                    </div>
                  </h2>
                  <div class="box2-row" v-for="(item, index) in medicalExamineList" :key="index">
                    <div class="row-l">
                      <div class="row1">
                        <el-select size="mini" v-model="item.examine" disabled>
                          <el-option v-for="item in examineList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                      <div class="row2">
                        <el-select size="mini" v-model="item.department" disabled >
                          <el-option v-for="item in departmentList" :key="item.value" :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                       <div class="row2">
                        <el-select size="mini" v-model="item.part" disabled>
                          <el-option v-for="item in partList" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </div>
                      <div class="row3">
                        附件日期：{{ item.shotDate ? item.shotDate.substring(0, 10) : '' }}
                      </div>
                      <div class="row4">
                        <div class="showImg" v-if="item.imgPathList.length">
                          <el-image v-for="(item2, index2) in item.imgPathList" :key="index2"
                            :src="$store.state.imgUrl + item2" @click="showImg($store.state.imgUrl + item2)"
                             fit="fill" ></el-image>
                        </div>
                        <div class="files" v-if="item.filePathList.length">
                          <div class="file-w" v-for="(item3, index3) in item.filePathList" :key="index3">
                            <i class="el-icon-document"></i>
                            <span @click="down($store.state.imgUrl + item3, index3)">预览附件</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div class="main_r_btm main_r_btm2" v-else>
            <div class="defaultTip">
              <img src="../../assets/img/quesheng.png" alt="">
              <p>您还没有诊断记录，请点击 <span @click="jumpInfo()">前往诊断</span></p>
            </div>
          </div>
          <div class="page2" v-if="recodeArr.length">
            <el-pagination small background layout="total,prev, pager, next,jumper" :total="totalR" :current-page.sync="pageNumR"
              :page-size="pageSizeR" @current-change="handleCurrentChangeR"></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 预览弹框 -->
    <el-dialog :visible.sync="showFiles" width="50%">
      <!-- 1. PDF 预览 -->
      <iframe v-if="fileType === 'pdf'" :src="fileUrl" style="width: 100%; height: 600px; border: none;"></iframe>
      <div class="wrap-show"  v-else>
        <vue-office-docx v-if="['doc', 'docx'].includes(fileType)" :src="fileUrl" @rendered="renderedHandler"
          @error="errorHandler" />
           <!-- <vue-office-docx
            v-if="['doc','docx'].includes(fileType)"
            :src="fileType == 'docx' ? fileUrl : docUrl"
            @rendered="renderedHandler"
            @error="errorHandler"
          /> -->
        <vue-office-excel v-else-if="['xls', 'xlsx'].includes(fileType)" :src="fileUrl" @rendered="renderedHandler"
          @error="errorHandler" />
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="downLoadFile">下 载</el-button>
        <el-button type="primary" @click="showFiles = false">关 闭</el-button>
      </span>
    </el-dialog>
    <img-editor ref="imgCropper"></img-editor>
  </div>
</template>

<script>
import VueOfficeDocx from '@vue-office/docx'
import VueOfficeExcel from '@vue-office/excel'
import '@vue-office/excel/lib/index.css'
import '@vue-office/docx/lib/index.css'
// import VueOfficePdf from '@vue-office/pdf'
import ImgEditor from "@/components/common/imgEditor.vue"


export default {
  name: "tradiIndex",
  data() {
    return {
      id: null,
      activeName: 0,
      showData: {},
      medicalMeridianRecordList: [],
      medicalExamineList: [],
      srcList: [],
      searchObj: {
        name: ""
      },
      detailSearchObj: {
        type: 0,
        createBy: '',
        date: []
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      pageNum: 1,
      pageSize: 16,
      total: 0,
      pageNumR: 1,
      pageSizeR: 6,
      totalR: 0,
      showFiles: false,
      fileUrl: '', // 文件URL
      docUrl: '',
      fileType: 'pdf', // 动态获取文件类型（如通过URL后缀判断）
      decodedContent: '',
      encoding: 'gbk', // 根据实际文件编码修改
      options1: [{
        value: 0,
        label: '查看全部'
      },
      {
        value: 1,
        label: '查看穴位'
      },
      {
        value: 2,
        label: '查看诊断'
      }
      ],
      options2: [],
      hzTableData: [],
      recodeArr: [{
        name: 'aaa',
        isShow: true
      }, {
        name: 'aaa',
        isShow: true
      }, {
        name: 'aaa',
        isShow: true
      }], //就诊记录数组
      timeout: null,
      value1: '',
      imgCropper:null 
    }
  },
  components: {
    VueOfficeDocx,
    VueOfficeExcel,
    ImgEditor 
    // VueOfficePdf
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.getList();
    this.dataDictionary('department');
    this.dataDictionary('examine');
     this.dataDictionary('part');
  },
  methods: {
    getFileType(fileUrl) {
      const extension = fileUrl.split('.').pop().toLowerCase();
      return ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt'].includes(extension) ? extension : 'unknown';
    },
    renderedHandler() {
      console.log('文档渲染完成')
    },
    errorHandler(e) {
      console.error('渲染失败', e)
    },
    // 跳转前往诊断
    jumpInfo() {
      this.$router.push({
        path: "/tradiInfo",
        query: {
          id: this.id
        }
      });
    },
    //医案列表
    getList() {
      let that = this;
      if (sessionStorage.getItem("userInfo")) {
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      }
      let params = {
        name: that.searchObj.name,
        pageNum: that.pageNum,
        pageSize: that.pageSize
      };
      let url = "medicalCasesPc/getYaByHz";
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            for (const item of res.data.list) item.addBorder = false;
            that.hzTableData = res.data.list;
            that.total = res.data.total;
            that.pageSize = res.data.pageSize;
            that.setCurrent(that.hzTableData[0]);
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    getDetailList() {
      let that = this;
      let params = {
        createBy: this.detailSearchObj.createBy,
        endTime: this.detailSearchObj.date ? this.detailSearchObj.date[1] : null,
        startTime: this.detailSearchObj.date ? this.detailSearchObj.date[0] : null,
        medicalId: this.id,
        pageNum: that.pageNumR,
        pageSize: that.pageSizeR
      };
      let url = "/medicakRecord/findPage";
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            this.recodeArr = res.data.list;
            that.totalR = res.data.total;
            that.pageSizeR = res.data.pageSize;
            that.getContentData(res.data.list[that.activeName].id);
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    getDoctor() {
      let that = this;
      let params = {
        medicalId: this.id
      };
      let url = "/medicakRecord/getUserByMedicalId";
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            this.options2 = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    searchChange() {
      // 清除之前的定时器
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      // 设置新的定时器
      this.timeout = setTimeout(() => {
        this.getList();
      }, 300);
    },

    addUser() {
      this.$router.push({
        path: "/tradiAddMedical"
      });
    },
    setCurrent(row) {
      this.id = row.id;
      this.$refs.singleTable.setCurrentRow(row);
      this.getDoctor();
      this.getDetailList();
      this.activeName = 0;
    },
    currentChange(val) {
      this.id = val.id;
      this.activeName = 0;
      this.detailSearchObj.type = 0;
      this.detailSearchObj.createBy = '';
      this.detailSearchObj.date = [];
      this.getDetailList();
      this.getDoctor();

    },
    handleCurrentChange(val) {
      this.getList();
    },
    handleCurrentChangeR(val) {
      this.activeName = 0;
      this.getDetailList()
    },
    handleChange(e) {
      if (e || e === 0) {
        let id = this.recodeArr[e].id;
        this.getContentData(id);
      }
    },
    getContentData(id) {
      let that = this;
      this.showData = {};
      let params = {
        id
      };
      let url = "/medicakRecord/getMedicalRecord";
      that.$http
        .post(url, params)
        .then(res => {
          res = res.data;
          if (res.code == 200) {
            this.showData = res.data;
            let medicalExamineList = res.data.medicalExamineList;
            medicalExamineList.forEach((item) => {
              if (item.path) {
                const { images, files } = that.splitPathByType(item.path);
                item.imgPathList = images;
                item.filePathList = files;
              } else {
                item.imgPathList = [];
                item.filePathList = [];
              }
            })
            this.medicalExamineList = medicalExamineList;
            let medicalMeridianList = res.data.medicalMeridianList;
            let medicalMeridianRecordList = res.data.medicalMeridianRecordList;
            medicalMeridianRecordList.forEach(record => {
              // 查找 medicalMeridianList 中 id 与当前 record.meridian 匹配的项
              // 注意：record.meridian 是数字类型，medicalMeridianList 的 id 是字符串类型，需转换后比较
              const matchedMeridian = medicalMeridianList.find(
                meridian => meridian.id === String(record.meridian)
              );
              // 如果找到匹配项，添加需要的字段
              if (matchedMeridian) {
                record.time = matchedMeridian.time;
                record.fire = matchedMeridian.fire;
                record.gold = matchedMeridian.gold;
                record.meridianNameDesc = matchedMeridian.meridianNameDesc;
                record.soil = matchedMeridian.soil;
                record.water = matchedMeridian.water;
                record.wood = matchedMeridian.wood;
              }
            });
            this.medicalMeridianRecordList = medicalMeridianRecordList;

          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(() => {
        });
    },
    showImg(url) {
      //this.srcList = [url]
      if(this.$refs.imgCropper){
        this.$refs.imgCropper.init(url)
      } 
    },
    down(url, index) {
      this.showFiles = true;
      this.fileUrl = url;
      this.fileType = this.getFileType(url);
      // if (this.fileType == 'doc') {
      //     this.getFile()
      //   }
    },
    getFile() {
      // doc文件转成docx格式进行预览
      let url = window.baseURL + '/mbd/Common/transformDocx?fileType=docx&fileUri=' + this.fileUrl
      this.getFileFromUrl(url).then(res => {
        this.docUrl = new File([res], '预览文档')
      })
    },
    getFileFromUrl(url, responseType = 'blob') {
      return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
        xhr.setRequestHeader('Authorization', 'Basic ' + window.Token)
        xhr.responseType = responseType
        // 加载时处理
        xhr.onload = () => {
          resolve(xhr.response)
        }
        xhr.onerror = e => {
          reject(e)
        }
        // 发送
        xhr.send()
      })
    },
    downLoadFile() {
      const link = document.createElement('a');
      link.href = this.fileUrl; // 文件路径
      link.click();
    },
    splitPathByType(pathStr) {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
      const images = [];
      const files = [];

      if (!pathStr) return { images, files };

      // 拆分路径字符串并遍历每个路径
      pathStr.split(',').forEach(path => {
        const extension = path.split('.').pop().toLowerCase();
        if (imageExtensions.includes(extension)) {
          images.push(path);
        } else {
          files.push(path);
        }
      });

      return { images, files };
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.tips {
  padding: 10px;
}

.dialog-footer .el-button {
  padding: 10px 20px;
  height: 40px!important;
}

.tips .el-alert {
  padding: 10px;
}

.el-select-dropdown__item {
  padding: 0 20px;
}

/* >>>.el-input-group__append,
>>>.el-input-group__prepend {
  padding: 0 10px 0 20px !important;
} */
.page2 {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.page {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.input_search {
  margin: 7px 0 17px;
  display: flex;
  justify-content: space-between;
}

.input_search .el-input {
  width: 82%;
  border-radius: 0%;
}

.input_search .el-input>>>.el-input__inner {
  border-radius: 0% !important;
}

.input_search button {
  width: 18%;
  height: 28px;
  border: none;
  background: #eee;
  border-radius: 0px;
  border: 1px solid #DCDFE6;
  border-left: none;
}

.mainWrap {
  display: flex;
}

.mainWrap .l {
  width: 265px;
  height: 780px;
  margin-right: 10px;
  background: #FFFFFF;
  padding: 9px;
  position: relative;
}

.mainWrap .l .page {
  position: absolute;
  left: 0;
  bottom: 10px;
}

.usrName {
  width: 40px;
  white-space: nowrap;
  /* 禁止换行 */
  overflow: hidden;
  /* 隐藏溢出内容 */
  text-overflow: ellipsis;
  /* 显示省略号 */
}

.mainWrap .r {
  width: 822px;
  min-height: calc(100vh - 530px);
}

.main_r_top {
  width: 100%;
  min-height: 62px;
  background: #FFFFFF;
  border-radius: 2px;
  padding: 8px;
}

.main_r_top_innr {
  width: 100%;
  padding: 8px;
  height: 47px;
  background: rgba(229, 232, 237, 0.26);
  border-radius: 2px;
  border: 1px solid #E5E8ED;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main_r_btm {
  margin-top: 9px;
  min-height: 660px;
  width: 100%;
  border-radius: 2px;
}

.main_r_btm2 {
  background-color: #fff;
}

.defaultTip {
  width: 100%;
  height: 700px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.defaultTip img {
  width: 300px;
  height: 220px;
  margin-top: 100px;
}

.defaultTip p {
  text-align: center;
  margin-top: 20px;

}

.defaultTip p span {
  color: #F66248;
  cursor: pointer;
}

.recodeOne {
  padding: 10px 17px;
}

.recodeOne .rec_t {
  display: flex;
  justify-content: space-between;
  color: #999999;
  font-size: 12px;
  border-bottom: 1px solid #CCD0D7;
  padding-bottom: 10px;
}

.rec_l {
  padding: 0 10px;
}

.rec-content {
  padding: 0px 15px 0px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

.rec_l span {
  margin-right: 30px;
}

.recodeOne .rec_t .spBtn {
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #ffffff;
  background-color: #B2B2B2;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;
}

.rec_zd {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  padding-bottom: 17px;
}

.rec_zd .zd_item {
  width: 254px;

}

.rec_zd .zd_item h4 {
  font-weight: 500;
  font-size: 13px;
  color: #333333;
  margin-bottom: 8px;
}

.zd_item-c {
  padding: 10px;
  overflow-y: auto;
}

.rec_zd .zd_item div {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 18px;
  height: 117px;
  background: rgba(229, 232, 237, 0.26);
  border-radius: 7px;
  border: 1px solid #E5E8ED;
}

.tradiWrap {
  background-color: #F3F6FB;
  padding-top: 10px;
  box-sizing: border-box;
  padding-bottom: 17px;
}
 
.contain {
  margin: 0 auto;
  width: 1100px !important;
}



.cusBtn {
  width: 100%;
  height: 30px;
  line-height: 30px;
  border-radius: 2px;
  background: #F66248;
  color: #FFFFFF;
  font-size: 12px;
  text-align: center;
  font-weight: 600;
  cursor: pointer;
}

.addBtn:before {
  content: '+';
  display: inline-block;
  width: 13px;
  height: 12px;
  line-height: 12px;
  font-size: 16px;
  border: 1px solid #FFFFFF;
  margin-right: 6px;
}

.jumpBtn {
  width: 81px;
}

.jumpBtn:before {
  content: '→';
  display: inline-block;
  width: 13px;
  height: 12px;
  line-height: 12px;
  font-size: 8px;
  border: 1px solid #FFFFFF;
  margin-right: 4px;
  border-radius: 50%;
  transform: translateY(-2px);
}

.zj {
  width: 100%;
  padding: 15px 15px;
}

.zj-item {
  line-height: 31px;
}

.zj-item-t {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.zj-item:last-of-type {
  border-bottom: none
}

.zj-item-box1 {
  width: 60px;
  background: #F8F8F8;
  border-radius: 3px;
  border: 1px solid #DDDDDD;
  padding: 0 10px;
}

.zj-item-box2 {
  padding: 0 10px;
  background: rgba(221, 221, 221, 0.41);
  border-radius: 2px;
  border: 1px solid #E5E8ED;
  font-weight: 600;
}


.zj-item-box4 {
  display: flex;
  flex-wrap: wrap;
}

.box4 {
  display: flex;
  align-items: center;
  color: #666;
  padding: 0px 8px;
  background: rgba(255, 255, 255, 0.88);
  border-radius: 2px;
  border: 1px dashed #E5E8ED;
  margin-right: 10px;
  margin-bottom: 10px;
}

.zj-item-box3 {
  min-width: 65px;
  text-align: right;
  font-size: 14px;
  color: #333333;
  font-weight: 600;
}

.box4-1 {}

.leftM {
  margin-left: 6px;
}

>>>.el-collapse-item__content {
  padding: 0px;
}

.yqhy {
  padding: 10px;
  border-top: 1px solid #eee;
}

.yqhy h2 {
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;

}

.btn {
  width: 90px;
  padding: 10rpx;
  background-color: #F66248;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  cursor: pointer;
}

.box2-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #F8F9FA;
  border: 1px dashed #E5E8ED;
  padding: 10px;
  margin-top: 5px;
}

.row-l {
  display: flex;
  align-items: center;
}

.row1,
.row2 {
  margin-right: 10px;
  width: 110px;
}

.row4 {
  display: flex;
  align-items: center;
}

.showImg {
  display: flex;
  margin-left: 10px;
}

.showImg .el-image {
  width: 50px;
  height: 50px;
  margin-right: 10px;
  border: 1px solid #eee;
}

.files {
  padding-top: 10px;
  display: flex;
  align-items: center;
}

.file-w {
  text-align: center;

  i {
    font-size: 20px;
    display: block;
    color: #999;
  }

  span {
    display: block;
    font-weight: 700;
    cursor: pointer;
    color: #999;
  }

  span:hover {
    color: #007aff;
  }
}
.wrap-show{
  width: 100%;
  height: 700px;
  overflow-y: auto;
}
/* 滚动条整体样式 */
::-webkit-scrollbar {
  width: 8px;
  /* 纵向滚动条宽度 */
  height: 8px;
  /* 横向滚动条高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

/* 滚动条滑块悬停效果 */
::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 滚动条边角 */
::-webkit-scrollbar-corner {
  background: transparent;
}

/* Firefox 滚动条样式 */
* {
  scrollbar-width: thin;
  /* 可选: auto | thin | none */
  scrollbar-color: #c1c1c1 #f1f1f1;
  /* 滑块颜色 轨道颜色 */
}
>>>.page .el-pagination__total{
  margin-right:0;
}
>>>.page .el-pagination__jump{
  margin-left:0;
}
>>>.page .el-pagination__editor.el-input{
  width:35px;
}
</style>



// WEBPACK FOOTER //
// src/components/traditionalAndWest/tradiIndex.vue